<template>
    <GetStartedLayout
        :errors="errors"
        :needHelp="false"
        bgGradient
        :img="null"
        :breadcrumbs="['Home', 'Student Survey']"
    >
        <v-col
            class="white--text text-center px-0"
            cols="12"
            sm="10"
            md="8"
            lg="6"
        >
            <StudentSurveyForm
                :errors="errors"
                :user="user"
                :hearAboutUsOptions="hearAboutUsOptions"
                :importantOptions="importantOptions"
                :locationUserId="locationUserId"
                :teacher="teacher"
                :source="source"
        /></v-col>
    </GetStartedLayout>
</template>

<script>
import GetStartedLayout from "../../Layouts/GetStartedLayout.vue";
import { Link } from "@inertiajs/vue2";
import StudentSurveyForm from "../../Components/StudentSurvey/StudentSurveyForm.vue";

export default {
    components: {
        GetStartedLayout,
        Link,
        StudentSurveyForm,
    },
    props: {
        errors: {},
        user: {
            type: Object,
            default: () => {},
        },
        hearAboutUsOptions: {
            type: Array,
            default: () => [],
        },
        importantOptions: {
            type: Array,
            default: () => [],
        },
        teacher: {
            type: Object,
            default: null,
        },
        locationUserId: {
            type: Number,
            default: null,
        },
        source: {
            type: String,
            default: null,
        },
    },
};
</script>

<style scoped></style>
